module.exports = __webpack_public_path__ + "img/info-circle.83a00b52.svg";